<ng-template #content>
    <div class="bg-surf-container-lowest pt-2 pb-2 shadow-md rounded">
        <ng-content></ng-content>
    </div>
</ng-template>
